import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Header, Loader } from 'semantic-ui-react';

export default ({
  dataLength,
  fetchMore,
  hasMore,
  children,
}) => (
  <InfiniteScroll
    style={{
      overflow: 'hidden',
    }}
    dataLength={dataLength}
    pullDownToRefresh={false}
    next={fetchMore}
    hasMore={hasMore}
    endMessage={(
      <Header as="h4" textAlign="center" color="grey">
        已經到底囉 !
      </Header>
    )}
    loader={<Loader active inline="centered">Loading</Loader>}
  >
    {children}
  </InfiniteScroll>
);
